/* Boat trailers found by VIN: three reference figures under the title.

   The parts store does not sell boat trailers, so Airtable has no specs for
   them and the hero showed a title, three tags and nothing else. fx-render.js
   already puts the closest render in the picture; this adds the same three
   figure row the rest of the store uses (value over label, hairline
   between), taken from the closest current model on futuratrailers.co.nz, and
   says so underneath, because these are a stand-in and not this trailer's own
   build sheet.

   The model is picked from the code the same way as the render: S or T is the
   axle count, the first digit is the boat length in metres (S-475-B is a
   single axle for a 4.75m boat). NZ figures are metric; converted here to the
   feet, inches and pounds the US store uses.

   Source, Series 4 to 7 pages, September 2026:
     S-4A-B        boats 3.5 to 4.5m, chassis up to 4750mm, max load 600kg
     S-5A-B        boats 4.5 to 5.5m, chassis 5050mm, max load 820kg
     S-6C-Q3       boats 5.5 to 6.5m, chassis up to 6750mm, max load 1450kg
     T-5A-Q3       boats 5 to 6.2m, chassis up to 5750mm, max load 1200kg
     T-6C-Q3TW     boats 6 to 6.6m, chassis up to 6750mm, max load 1900kg
     T-7D-Q4TW-25  boats 6.5 to 8m, chassis up to 7750mm, max load 1800kg */
(function () {
  'use strict';

  var SPECS = {
    S4: { model: 'S-4A-B', boat: "14' 9\"", length: "15' 7\"", load: '1,323 lbs' },
    S5: { model: 'S-5A-B', boat: "18' 1\"", length: "16' 7\"", load: '1,808 lbs' },
    S6: { model: 'S-6C-Q3', boat: "21' 4\"", length: "22' 2\"", load: '3,197 lbs' },
    T5: { model: 'T-5A-Q3', boat: "20' 4\"", length: "18' 10\"", load: '2,646 lbs' },
    T6: { model: 'T-6C-Q3TW', boat: "21' 8\"", length: "22' 2\"", load: '4,189 lbs' },
    T7: { model: 'T-7D-Q4TW-25', boat: "26' 3\"", length: "25' 5\"", load: '3,968 lbs' }
  };
  var CODE = /(?:^|[^A-Z0-9])([ST])\s*-?\s*(\d)(?:\d|[A-D])/;

  function keyFor(text) {
    var m = CODE.exec(String(text || '').toUpperCase());
    if (!m) return 'S5';
    var metres = +m[2];
    if (m[1] === 'T') return metres <= 5 ? 'T5' : metres === 6 ? 'T6' : 'T7';
    return metres <= 4 ? 'S4' : metres === 5 ? 'S5' : 'S6';
  }

  function heroText() {
    var t = document.querySelector('.vin-modal #vinTrailerTitle');
    if (!t || !/boat/i.test(t.textContent || '')) return '';
    var s = t.textContent;
    ['#vinFxHeroPills', '#vinTrailerExtraSpecs', '#vinTrailerDescription'].forEach(function (sel) {
      var el = document.querySelector('.vin-modal ' + sel);
      if (el) s += ' ' + el.textContent;
    });
    return s;
  }

  function cell(value, label) {
    var c = document.createElement('div');
    c.className = 'fx-boat-specs__cell';
    var b = document.createElement('b');
    b.textContent = value;
    var l = document.createElement('span');
    l.textContent = label;
    c.appendChild(b);
    c.appendChild(l);
    return c;
  }

  function sync() {
    timer = 0;
    var block = document.querySelector('.vin-modal .fx-boat-specs');
    var text = heroText();
    if (!text) {
      if (block) block.parentNode.removeChild(block);
      return;
    }
    var k = keyFor(text);
    var anchor = document.querySelector('.vin-modal #vinFxHeroPills') ||
      document.querySelector('.vin-modal #vinTrailerTitle');
    if (!anchor) return;
    if (block && block.getAttribute('data-k') === k && block.previousElementSibling === anchor) return;
    if (block) block.parentNode.removeChild(block);

    var s = SPECS[k];
    block = document.createElement('div');
    block.className = 'fx-boat-specs';
    block.setAttribute('data-k', k);
    var dims = document.createElement('div');
    dims.className = 'fx-boat-specs__dims';
    dims.appendChild(cell(s.boat, 'Boat Length'));
    dims.appendChild(cell(s.length, 'Trailer Length'));
    dims.appendChild(cell(s.load, 'Load Capacity'));
    block.appendChild(dims);
    var note = document.createElement('p');
    note.className = 'fx-boat-specs__note';
    note.textContent = 'Figures from the closest current model, the ' + s.model + '. For reference only.';
    block.appendChild(note);
    anchor.parentNode.insertBefore(block, anchor.nextSibling);
  }

  var timer = 0;
  function schedule() { if (!timer) timer = setTimeout(sync, 30); }

  function start() {
    sync();
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
